import { useCallback, useEffect, useRef, useState } from "react";
import contactsDirectoryApi from "../../../api/contactsDirectoryApi";
import { useContacts } from "../contexts/ContactsContext";

const PAGE_SIZE = 200;
const MAX_PAGES = 100;

/**
 * Hook load TOÀN BỘ friend_requests theo direction. Không phân trang.
 */
export const useFriendRequests = ({ direction = "all", status } = {}) => {
  const { selectedShopIds, search } = useContacts();
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const abortRef = useRef(null);

  const load = useCallback(async () => {
    if (abortRef.current) abortRef.current.abort();
    const ctrl = new AbortController();
    abortRef.current = ctrl;

    if (!selectedShopIds.length) {
      setItems([]);
      setTotal(0);
      return;
    }
    setLoading(true);
    setError(null);

    try {
      const all = [];
      let totalCount = 0;
      let page = 1;
      while (page <= MAX_PAGES) {
        const data = await contactsDirectoryApi.getFriendRequests(
          {
            shopIds: selectedShopIds,
            direction,
            status,
            page,
            limit: PAGE_SIZE,
          },
          ctrl.signal,
        );
        const rows = Array.isArray(data?.items) ? data.items : [];
        all.push(...rows);
        totalCount = data?.total || totalCount;
        // Service trả merged cho N shop — không có flag hasMore chuẩn, dùng rows.length
        if (rows.length < PAGE_SIZE) break;
        page += 1;
      }

      let list = all;
      if (search && search.trim()) {
        const q = search.trim().toLowerCase();
        list = list.filter((r) => {
          const name = (
            r.partner?.name ||
            r.partner?.zaloName ||
            ""
          ).toLowerCase();
          const phone =
            r.partner?.phone ||
            (Array.isArray(r.partner?.phoneList) ? r.partner.phoneList[0] : "") ||
            "";
          return name.includes(q) || String(phone).includes(q);
        });
      }

      setItems(list);
      setTotal(totalCount || list.length);
    } catch (e) {
      if (e.name !== "CanceledError" && e.name !== "AbortError") {
        setError(e.message || "Lỗi tải danh sách");
      }
    } finally {
      setLoading(false);
    }
  }, [selectedShopIds, direction, status, search]);

  useEffect(() => {
    load();
    return () => {
      if (abortRef.current) abortRef.current.abort();
    };
  }, [load]);

  return { items, total, loading, error, reload: load };
};

export default useFriendRequests;
